// lib/inspFollow.mjs — R114 review (insp-move #8 / ask-fit #2): what the page
// says after a clean move that asked its inspection to follow
// (POST /turns/:id/move { with_inspection: true }). Pure; shared by the
// Housekeeping board and the Stays calendar so the rule can't drift.
//
// The server answers inspection: { moved:true, from, to, inspector } or
// { moved:false, from, code, reason }. Codes (server/assetops.js followCode):
//   none / done / stale / unchanged — nothing was stranded: there was no
//       inspection on that day, it was already inspected, or it had already
//       been moved elsewhere. Quiet.
//   collision / blocked / office_only / error — the clean moved but its
//       inspection STAYED on the old date. The confirm promised it would move,
//       so the page must say so (the split is what R114 set out to remove).

export const QUIET_CODES = Object.freeze(['none', 'done', 'stale', 'unchanged']);
export const WARN_CODES = Object.freeze(['collision', 'blocked', 'office_only', 'error']);

const clean = (s) => String(s == null ? '' : s).trim().replace(/[.\s]+$/, '');

// → the warning text, or null when there is nothing to warn about.
//   inspection: the response's inspection object (may be missing)
//   opts.to:   the clean's new date (display string)
//   opts.from: the clean's old date (display string) — used when the server
//              didn't echo one
//   opts.name: the property name (optional)
export function followWarning(inspection, opts = {}) {
  const ins = inspection && typeof inspection === 'object' ? inspection : null;
  if (!ins || ins.moved !== false) return null;
  const code = String(ins.code || '');
  if (!WARN_CODES.includes(code)) return null;
  const from = clean(opts.fromLabel || ins.from || opts.from || 'its old date');
  const to = clean(opts.to || 'the new date');
  const what = opts.name ? `The ${clean(opts.name)} clean` : 'The clean';
  const why = clean(ins.reason) || 'it could not be moved';
  return `${what} moved to ${to}, but its inspection stayed on ${from}. Why: ${why}. To fix it: Inspections → ⋯ → Move to date.`;
}
